import { IconLetter } from 'kompare-ui-library';
import React, { useEffect } from 'react';
import styled from "@emotion/styled";
import { i18n, mediaQuery, persistor, setProgressBarPercentage, useAppDispatch, usePaymentSlip } from 'src/common';
import { Button, Flex, Loader, StatusMessage } from 'src/components';
import { useNavigate, useParams } from 'react-router-dom';
import { colors, footer, header } from 'src/theme';
import { AppRoutes } from '../_router/app.routes';

const ButtonContainerStyle = styled.div({
  marginTop: 32,
  textAlign: 'center',
})

const ButtonStyle = styled(Button)({
  [mediaQuery('mobile')]: {
    marginRight: 24,
  }
});

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutPaymentSentPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const params = useParams<{ offerId: string }>();
  const offerId = params.offerId as string;

  useEffect(() => {
    dispatch(setProgressBarPercentage(0));
    persistor.purge();
  }, []);

  const { downloadSlip, loading, PaymentSlip } = usePaymentSlip(offerId, 'oneTime');

  if (loading) return <Loader page />;

  const handlePay = () => {
    navigate(`${AppRoutes.CHECKOUT_EXECUTE_PAYMENT.fullPath}/${offerId}`)
  };

  const Buttons = () => (
    <ButtonContainerStyle>
      <ButtonStyle btnType='primary' onClick={handlePay}>
        {i18n.t('pages.checkoutPaymentSentPage.showBarcodeAndPayButton')}
      </ButtonStyle>
      <Button btnType='textBlack' onClick={() => downloadSlip()}>
        {i18n.t('pages.checkoutPaymentSentPage.downloadSlipButton')}
      </Button>
    </ButtonContainerStyle>
  );

  return (
    <FlexStyle justify='center' align='center'>
      <StatusMessage buttons={<Buttons />} icon={<IconLetter color={colors.icon4} />} title={i18n.t('pages.checkoutPaymentSentPage.title')} subtitle={i18n.t('pages.checkoutPaymentSentPage.subtitle')} />
      <PaymentSlip />
    </FlexStyle>
  );
}

export default CheckoutPaymentSentPage;